<template>
  <article class="customizer">
    <OptionsContainer/>
  </article>
</template>
<script>
import OptionsContainer from './../components/options/OptionsContainer'

export default {
  name: 'Customizer',
  components: {
    OptionsContainer,
  },
}
</script>
<style lang="scss" scoped>
article.customizer {
  position: absolute;
  top: 0;
  z-index: 10;
  height: 100%;
  width: 100vw;
  overflow: hidden;
}
</style>
